/* eslint-disable  @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { omit } from 'ramda';
export function ConditionalWrapper(props) {
  var children = props.children;
  var wrappersProps = React.useMemo(function () {
    return omit(['if', 'ThenComponent', 'thenRender', 'ElseComponent', 'elseRender'], props);
  }, [props]);
  var condition = typeof props.if === 'function' ? props.if() : props.if;

  if (condition) {
    if (props.ThenComponent) {
      var ThenComponent = props.ThenComponent;
      return /*#__PURE__*/React.createElement(ThenComponent, wrappersProps);
    } else {
      return props.thenRender(children);
    }
  } else {
    if (props.ElseComponent) {
      var ElseComponent = props.ElseComponent;
      return /*#__PURE__*/React.createElement(ElseComponent, wrappersProps);
    } else if (props.elseRender) {
      return props.elseRender(children);
    }

    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }
}